import { render, staticRenderFns } from "./SenaEditionGames.vue?vue&type=template&id=3fdaca5e&"
import script from "./SenaEditionGames.vue?vue&type=script&lang=js&"
export * from "./SenaEditionGames.vue?vue&type=script&lang=js&"
import style0 from "./SenaEditionGames.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports